import type { CornerRadius } from '@/components/canvas/document/publicTypes';

/**
 * 统一解析元素的「四角圆角」。
 * 供 DOM（CSS）、SVG path、Canvas 等路径复用同一套语义。
 */
export interface CornerRadiiPx {
  tl: number;
  tr: number;
  br: number;
  bl: number;
}

export function resolveCornerRadiiPx(el: { appearance: { radius?: CornerRadius } }): CornerRadiiPx {
  const radius = el.appearance.radius;
  const base = Math.max(0, Number(radius?.all) || 0);
  return {
    tl: Math.max(0, Number(radius?.topLeft) || base),
    tr: Math.max(0, Number(radius?.topRight) || base),
    br: Math.max(0, Number(radius?.bottomRight) || base),
    bl: Math.max(0, Number(radius?.bottomLeft) || base),
  };
}

/** CSS `border-radius`：左上起顺时针，与 `resolveCornerRadiiPx` 顺序一致 */
export function cornerRadiiToCssBorderRadius(r: CornerRadiiPx): string {
  return `${r.tl}px ${r.tr}px ${r.br}px ${r.bl}px`;
}

/**
 * 圆角矩形 SVG path（局部坐标 0,0 — w,h）。与 Canvas `arcTo` 圆角矩形构造一致。
 */
export function roundedRectPathData(w: number, h: number, r: CornerRadiiPx): string {
  const { tl, tr, br, bl } = r;
  if (w <= 0 || h <= 0) return '';
  const parts: string[] = [`M ${tl} 0`, `L ${w - tr} 0`];
  if (tr > 0) parts.push(`A ${tr} ${tr} 0 0 1 ${w} ${tr}`);
  else parts.push(`L ${w} 0`);
  parts.push(`L ${w} ${h - br}`);
  if (br > 0) parts.push(`A ${br} ${br} 0 0 1 ${w - br} ${h}`);
  else parts.push(`L ${w} ${h}`);
  parts.push(`L ${bl} ${h}`);
  if (bl > 0) parts.push(`A ${bl} ${bl} 0 0 1 0 ${h - bl}`);
  else parts.push(`L 0 ${h}`);
  parts.push(`L 0 ${tl}`);
  if (tl > 0) parts.push(`A ${tl} ${tl} 0 0 1 ${tl} 0`);
  else parts.push(`L 0 0`);
  parts.push('Z');
  return parts.join(' ');
}
